// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Secure CV
 * Service Secure CV
 * Version: v.0.1.0
 */import { LivenessState } from './LivenessState';
import { NullFilter } from './NullFilter';

export const LivenessFilter = {...LivenessState,...NullFilter,} as const
export type LivenessFilter = typeof LivenessFilter[keyof typeof LivenessFilter];
